import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import notFound from '@src/LottieAnimations/404.json';
import { LottieLite } from '@src/LottieAnimations/LottieLite';

const PageNotFound: FC = () => {
  const navigate = useNavigate();

  /*TODO move all these files into css// IMPORTANT*/
  const containerStyle: React.CSSProperties = {
    fontFamily: 'Plus Jakarta Sans',
    textAlign: 'center',
    backgroundColor: '#57568e',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
  };

  const headingStyle: React.CSSProperties = {
    fontSize: '36px',
    color: '#fff',
    marginBottom: '20px',
  };

  const paragraphStyle: React.CSSProperties = {
    fontSize: '18px',
    color: '#fff',
    margin: '30px 0',
  };

  const buttonStyle: React.CSSProperties = {
    padding: '10px 20px',
    fontSize: '16px',
    color: '#fff',
    backgroundColor: '#4f7eff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    textDecoration: 'none',
  };

  const handleGoBack = () => {
    navigate('/', { replace: true });
  };

  return (
    <div data-test-id="c-page-not-found" style={containerStyle}>
      <LottieLite animationData={notFound} style={{ width: 700 }} />
      <h1 style={headingStyle}>Oops! Page Not Found</h1>
      <p style={paragraphStyle}>
        It seems the page you're looking for doesn't exist.
      </p>
      <button style={buttonStyle} onClick={handleGoBack}>
        Go To Home Page
      </button>
    </div>
  );
};

export default PageNotFound;
